export interface CashTransaction {
  id: string;
  date: string;
  description: string;
  type: 'debit' | 'credit';
  amount: number;
  category: string;
  reference?: string;
  userId: string;
  balance: number; // Running balance after this transaction
  createdAt: number;
  linkedEntityType?: 'client' | 'vendor' | 'expense' | 'advance' | 'loan' | 'capital' | 'purchase' | '';
  linkedEntityId?: string;
  linkedEntityName?: string;
  linkedInvoiceId?: string;
}

export interface BankTransaction {
  id: string;
  date: string;
  description: string;
  type: 'debit' | 'credit';
  amount: number;
  category: string;
  reference?: string;
  bank: string;
  accountNumber: string;
  userId: string;
  balance: number; // Running balance after this transaction
  chequeNumber?: string;
  createdAt: number;
  linkedEntityType?: 'client' | 'vendor' | 'expense' | 'advance' | 'loan' | 'capital' | 'purchase' | '';
  linkedEntityId?: string;
  linkedEntityName?: string;
  linkedInvoiceId?: string;
}

export interface CapitalEntry {
  id: string;
  date: string;
  description: string;
  amount: number;
  userId: string;
  createdAt: number;
}

export interface AccountSettings {
  financialYearStart: string; // Format: YYYY-MM-DD
  openingCashBalance: number;
  openingBankBalances: BankBalance[];
  capitalContribution: number;
  userId: string;
  updatedAt: number;
}

export interface BankBalance {
  bankName: string;
  accountNumber: string;
  balance: number;
  accountType?: string;
  description?: string;
}

export interface BankAccount {
  id: string;
  bankName: string;
  accountNumber: string;
  accountType: string;
  ifscCode: string;
  branch: string;
  userId: string;
  createdAt: number;
}

export const TRANSACTION_CATEGORIES = [
  // Income categories
  'Sales',
  'Services',
  'Interest Income',
  'Other Income',
  
  // Expense categories
  'Purchases',
  'Rent',
  'Salaries',
  'Utilities',
  'Office Supplies',
  'Travel',
  'Maintenance',
  'Insurance',
  'Marketing',
  'Professional Fees',
  'Bank Charges',
  'Miscellaneous Expenses',
  
  // Asset/Liability categories
  'Equipment Purchase',
  'Loan Payment',
  'Loan Disbursement',
  'Capital Contribution',
  'Owner Withdrawal',
  'GST Payment',
  'TDS Payment',
  'Advance Payment',
  'Deposits',
  'Refunds',
  'Transfer to Bank',
  'Transfer from Bank'
];

export const ACCOUNT_TYPES = [
  'Current Account',
  'Savings Account',
  'Cash Credit',
  'Overdraft',
  'Fixed Deposit'
];

export interface MonthlyTotal {
  id: string;
  userId: string;
  year: number;
  month: number;  // 1-12
  totalSales: number;
  totalPurchases: number;
  totalExpenses: number;
  netProfit: number;
  inventoryClosingBalance?: number; // Closing balance of inventory at cost value
  createdAt: number;
  updatedAt: number;
} 